import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { ShellProvider } from "../../components/shared/headings";
import { PortalHeader } from "./PortalHeader";
import { agencyApi } from "./api";

export const SHELL_PATHS = ["/business/portal", "/business/groups", "/business/cases", "/business/workspace"];
export const inShellPath = (p) => SHELL_PATHS.some((s) => p === s || p.startsWith(`${s}/`));
// Partners (and applicant-side demo accounts acting as an agency) live inside the portal chrome; staff, admins and visitors keep the public site.
export const isAgencyUser = (u) => Boolean(u && (u.role === "partner" || (u.demo_access && u.demo_partner_id && u.role === "applicant")));

let cache = { key: "", home: null };

/* Portal chrome for the agency pages outside /business/portal (group board, cases, referrals). */
export function PortalShell({ children }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const key = `${user?.user_id}|${user?.demo_partner_id || ""}`;
  const [home, setHome] = useState(cache.key === key ? cache.home : null);
  useEffect(() => {
    if (!isAgencyUser(user)) return;
    if (cache.key === key && cache.home) { setHome(cache.home); return; }
    let on = true;
    agencyApi("/home").then((h) => { cache = { key, home: h }; if (on) setHome(h); }).catch(() => {});
    return () => { on = false; };
  }, [key, user]);
  const onTab = (t, tourId) => navigate(`/business/portal?tab=${t}${tourId ? `&tour=${tourId}` : ""}`);
  const readOnly = Boolean(home && !home.locked && !home.licence?.active);
  const demo = Boolean(user?.demo_access && user?.role !== "partner");
  return (
    <ShellProvider value>
      <div className="min-h-screen bg-gray6/40" data-testid="portal-shell" data-path={pathname}>
        <PortalHeader home={home} tab="" onTab={onTab} onAdd={() => navigate(readOnly ? "/business/portal?tab=billing" : "/business/portal?add=1")} readOnly={readOnly} demo={demo} onSwitch={() => navigate("/business/portal")} />
        <main>{children}</main>
      </div>
    </ShellProvider>
  );
}
